import { useSubscribers } from './useSubscribers';
import { useServices } from 'app/hooks';
import { ReloadRequiredMessage } from '../out/messages/ReloadRequiredMessage';
import { v4 as uuid } from 'uuid';
import {
    useDispatchShowInfo,
    useDispatchShowWarning,
} from 'notification/store/dispatcher';
import { environment } from 'environment';

export function useReloadRequired() {
    const { embeddedApiService } = useServices();

    const subscribers = useSubscribers('RELOAD_REQUIRED');
    const showInfo = useDispatchShowInfo();
    const showWarning = useDispatchShowWarning();

    const emit = (reason: string) => {
        const message: ReloadRequiredMessage = {
            topic: 'RELOAD_REQUIRED',
            payload: {
                correlationId: uuid(),
                reason,
            },
        };
        return embeddedApiService.send(message);
    };

    const reloadPossible = environment.isDevMode || subscribers.length > 0;

    const onReloadClicked = reloadPossible
        ? () => {
              const { success } = emit('NewportReloadButton clicked');
              if (success) {
                  showInfo('Reload request sent to Newport');
              } else {
                  showWarning('Error sending reload request to Newport');
              }
          }
        : undefined;

    return { reloadPossible, onReloadClicked };
}
